<template lang="pug">
.donations-heatmap
  div#donations-heatmap-vega
</template>

<script>
import vegaEmbed from 'vega-embed'
import { authBackend } from '../api'
import { parseISO } from 'date-fns'

export default {
  data() {
    return {
      data: []
    }
  },

  async mounted() {
    this.data = (await authBackend().get('/api/dashboard/donation/heatmap')).data
    this.data.map((row) => {
      row.date =
        new Intl.DateTimeFormat('et-ee', { dateStyle: 'medium' })
          .format(parseISO(row.date))
          .toString()
    })
    vegaEmbed('#donations-heatmap-vega', {
      '$schema': 'https://vega.github.io/schema/vega-lite/v5.json',
      'data': { 'values': this.data },
      'mark': {
        'type': 'rect',
        'cornerRadius': 5,
        'width': 18,
        'height': 18,
        'tooltip': {
          'expr': "datum.date + ':  ' + datum.total + '€'"
        }
      },
      'encoding': {
        'x': {
          'field': 'week',
          'type': 'ordinal',
          'title': null,
          'axis': {
            'domain': false,
            'ticks': false,
            'labels': false
          }
        },
        'y': {
          'field': 'day',
          'type': 'nominal',
          'title': null,
          'axis': {
            'offset': 5,
            'grid': false,
            'domain': false,
            'ticks': false,
            'labelExpr': "{0: 'Esmaspäev', 1: 'Teisipäev', 2: 'Kolmapäev', 3: 'Neljapäev', 4: 'Reede', 5: 'Laupäev', 6: 'Pühapäev'}[datum.value]",
            'labelFontSize': 16,
            'labelColor': '#363636'
          }
        },
        'color': {
          'field': 'total',
          'type': 'ordinal',
          'legend': null
        }
      },
      'config': {
        'view': {
          'stroke': 'transparent'
        },
        'range': {
          'ordinal': {
            'scheme': ['#eee', '#6eb8c5', '#2f6790']
          }
        }
      }
    }, {
      'actions': false
    })
  }
}
</script>

<style lang="scss">
.donations-heatmap {
  padding: 2rem 1rem 2rem 1rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
